module.exports = __webpack_public_path__ + "img/arrow-right.9fadc384.svg";